// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__Z6H3Z","spinning":"Spinner_spinning__TYHxj"};